<template>
 <div class="row">
   <div class="col-md-12">
     <div class="box box-primary">
       <div class="box-header with-border">
         <h3 class="box-title"><i class="fa fa-industry mr-5"></i>{{storeData.name}}</h3>
         <div class="box-tools pull-right">
           <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
           </button>
         </div>
       </div>
       <div class="box-controls">
         <button class="btn btn-info" @click="$router.push('/accounting/companies/' + $route.params.company_id)">Zurück zum Unternehmen</button>
       </div>
       <div class="box-body">
         <div class="row">
           <div class="col-xs-12">
             <h4 class="page-header">
               <i class="fa fa-user mr-5"></i> {{'store_number' | translate}}: {{storeData.store_number}}
             </h4>
           </div>
           <div class="col-xs-12">
             <div class="row">
               <div class="col-md-3 col-sm-6 col-xs-12">
                 <div class="form-group">
                   <label for="erp_store_id">{{'erp_store_id' | translate}}</label>
                   <input type="text" class="form-control" id="erp_store_id" :placeholder="'erp_store_id' | translate" v-model="storeData.erp_store_id">
                 </div>
               </div>
               <div class="col-md-3 col-sm-6 col-xs-12">
                 <div class="form-group">
                   <label for="sap_number">SAP-{{'number' | translate}}</label>
                   <input class="form-control" id="sap_number" :placeholder="'contact_phone' | translate" type="text" v-model="storeData.sap_number">
                 </div>
               </div>
               <div class="col-md-3 col-sm-6 col-xs-12">
                 <div class="form-group">
                   <label for="contact_email">{{'order_email' | translate}}</label>
                   <input type="text" class="form-control" id="order_email" :placeholder="'erp_store_id' | translate" v-model="storeData.order_email">
                 </div>
               </div>
             </div>
             <hr>
           </div>
           <div class="col-md-4 col-sm-6 col-xs-12">
             <div class="form-group">
               <label for="contact_name">{{'contact_name' | translate}}</label>
               <input class="form-control" id="contact_name" :placeholder="'contact_name' | translate" type="text" v-model="storeData.contact_name">
             </div>
           </div>
           <div class="col-md-4 col-sm-6 col-xs-12">
             <div class="form-group">
               <label for="contact_email">{{'contact_email' | translate}}</label>
               <input class="form-control" id="contact_email" :placeholder="'contact_email' | translate" type="text" v-model="storeData.contact_email">
             </div>
           </div>
           <div class="col-md-4 col-sm-6 col-xs-12">
             <div class="form-group">
               <label for="contact_phone">{{'contact_phone' | translate}}</label>
               <input class="form-control" id="contact_phone" :placeholder="'contact_phone' | translate" type="text" v-model="storeData.contact_phone">
             </div>
           </div>
         </div>
         <div class="row">
           <div class="col-sm-6 col-xs-12">
             <h4 class="page-header">
               <i class="fa fa-file-text-o mr-5"></i> {{'store_address' | translate}}
             </h4>
             <div class="row">
               <div class="col-xs-12">
                 <div class="form-group">
                   <label for="shop_name">{{'shop_name' | translate}}</label>
                   <input class="form-control" id="shop_name" :placeholder="'shop_name' | translate" type="text" v-model="storeData.name">
                 </div>
               </div>
               <div class="col-sm-9 col-xs-12">
                 <div class="form-group">
                   <label for="street">{{'street' | translate}}</label>
                   <input class="form-control" id="street" :placeholder="'street' | translate" type="text" v-model="storeData.street">
                 </div>
               </div>
               <div class="col-sm-3 col-xs-12">
                 <div class="form-group">
                   <label for="street_number">{{'street_no' | translate}}</label>
                   <input class="form-control" id="street_number" :placeholder="'street_number' | translate" type="text" v-model="storeData.street_no">
                 </div>
               </div>
               <div class="col-sm-4 col-xs-12">
                 <div class="form-group">
                   <label for="zip_code">{{'zip_code' | translate}}</label>
                   <input class="form-control" id="zip_code" :placeholder="'zip_code' | translate" type="text" v-model="storeData.zip_code">
                 </div>
               </div>
               <div class="col-sm-8 col-xs-12">
                 <div class="form-group">
                   <label for="city">{{'city' | translate}}</label>
                   <input class="form-control" id="city" :placeholder="'city' | translate" type="text" v-model="storeData.city">
                 </div>
               </div>
             </div>
           </div>
           <div class="col-sm-6 col-xs-12">
             <h4 class="page-header">
               <i class="fa fa-truck mr-5"></i> {{'shipping_store_address' | translate}}
             </h4>
             <div class="row">
               <div class="col-xs-12">
                 <div class="form-group">
                   <label for="company">{{'shop_name' | translate}}</label>
                   <input class="form-control" id="company" :placeholder="'shop_shipping_name' | translate" type="text" v-model="storeData.shipping_name">
                 </div>
               </div>
               <div class="col-sm-9 col-xs-12">
                 <div class="form-group">
                   <label for="shippingStreet">{{'shipping_street' | translate}}</label>
                   <input class="form-control" id="shippingStreet" :placeholder="'shippingStreet' | translate" type="text" v-model="storeData.shipping_street">
                 </div>
               </div>
               <div class="col-sm-3 col-xs-12">
                 <div class="form-group">
                   <label for="street_number_no">{{'shipping_street_no' | translate}}</label>
                   <input class="form-control" id="street_number_no" :placeholder="'street_number_no' | translate" type="text" v-model="storeData.shipping_street_no">
                 </div>
               </div>
               <div class="col-sm-4 col-xs-12">
                 <div class="form-group">
                   <label for="shipping_zip_code">{{'shipping_zip_code' | translate}}</label>
                   <input class="form-control" id="shipping_zip_code" :placeholder="'shipping_zip_code' | translate" type="text" v-model="storeData.shipping_zip_code">
                 </div>
               </div>
               <div class="col-sm-8 col-xs-12">
                 <div class="form-group">
                   <label for="shippingCity">{{'shipping_city' | translate}}</label>
                   <input class="form-control" id="shippingCity" :placeholder="'shipping_city' | translate" type="text" v-model="storeData.shipping_city">
                 </div>
               </div>
             </div>
           </div>
         </div>
         <hr>
         <div class="row">
           <div class="col-xs-6"></div>
           <div class="col-xs-6 text-right">
             <a @click="postData" class="btn btn-app btn-success">
               <i class="fa fa-save"></i>{{'submit' | translate | capitalize}}
             </a>
           </div>
         </div>
         <hr>
         <div class="row">
           <div class="col-xs-12">
             <h4 class="page-header">
               <i class="fa fa-file-text-o mr-5"></i> {{'cnc_configuration' | translate}}
             </h4>
             <div class="row">
               <div class="col-sm-12 col-lg-6">
                 <label for="reservation_email">{{'cnc_reservation_email' | translate}}</label>
               </div>
               <div class="col-sm-12 col-lg-6">
                 <input class="form-control" id="reservation_email" :placeholder="'cnc_reservation_email' | translate" type="text" v-model="storeData.reservation_email">
               </div>
               <div class="col-xs-12 mt-10">
                 <button @click="updateReservationEmail()" class="btn btn-success pull-right">Click&Collect Email-Adresse aktualisieren</button>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>
</template>
<script>
export default {
  props: ['storeData'],
  data () {
    return {}
  },
  methods: {
    updateReservationEmail() {
      API.put(`accounting/companies/${this.$route.params.company_id}/stores/${this.storeData.id}/reservationEmail`, {"reservation_email": this.storeData.reservation_email})
        .then(response => {
          this.$emit('alert', response)
        })
        .catch(error => {
          this.$emit('alert', error)
        })
    },
    postData () {
      let url = `accounting/companies/${this.$route.params.company_id}/stores/${this.storeData.id}`
      API.put(url, this.storeData)
        .then(response => {
          this.$emit('alert', response)
        })
        .catch(error => {
          this.$emit('alert', error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/StoreEdit.vue